<template>
  <div>
    <gmap-polyline :path="path"></gmap-polyline>
  </div>
</template>

<script>

export default {
  name: 'fox-path',
  props: ['fox'],
  computed: {
    path() {
      return this.$store.getters[this.fox].map((el)=> {
        return {lat: parseFloat(el.lat), lng: parseFloat(el.lng)};
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/maps/FoxPath.vue